function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M46.1908 45H30.5C15.3122 45 3 32.6878 3 17.5C3 9.54835 11.3231 4.33994 18.4745 7.81634L29.0497 12.9571C33.2521 14.9999 37.9573 15.7784 42.5937 15.198L55.6337 13.5657C61.7132 12.8047 67.632 11.0763 73.1658 8.44621L78.151 6.07684C83.0088 3.76798 88.3869 2.77249 93.7493 3.18956L114.114 4.77346C120.853 5.2976 125.741 11.4152 124.766 18.1037L123.966 23.5886C123.853 24.3605 123.334 25.0122 122.607 25.2949C117.642 27.2258 115.826 33.3172 118.922 37.6523L120.038 39.2148C121.768 41.6364 120.037 45 117.061 45H110.436C108.66 45 106.948 44.3308 105.642 43.1256L101.918 39.6881C97.1559 35.2919 90.0648 34.5625 84.507 37.8972L82.3531 39.1896C80.3176 40.4109 77.7177 40.1264 75.9945 38.4939C72.0891 34.794 66.1155 34.364 61.7204 37.4664L55.0159 42.199C52.434 44.0215 49.3512 45 46.1908 45Z",
  stroke: "currentColor",
  strokeWidth: 6
});

function SvgTrack5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 48,
    viewBox: "0 0 128 48",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrack5);
export default __webpack_public_path__ + "static/media/track5.409a8ec4.svg";
export { ForwardRef as ReactComponent };